/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  KillswitchCapabilityKey,
  KillswitchCapabilityKey$inboundSchema,
} from "./killswitchcapabilitykey.js";
import {
  KillswitchHistoryEvent,
  KillswitchHistoryEvent$inboundSchema,
} from "./killswitchhistoryevent.js";
import {
  KillswitchSchedule,
  KillswitchSchedule$inboundSchema,
} from "./killswitchschedule.js";
import {
  KillswitchScope,
  KillswitchScope$inboundSchema,
} from "./killswitchscope.js";
import {
  KillswitchStatus,
  KillswitchStatus$inboundSchema,
} from "./killswitchstatus.js";

export type KillswitchDetail = {
  capabilityLabel: string;
  externalNote: string;
  history: Array<KillswitchHistoryEvent>;
  historyTruncated: boolean;
  id: string;
  internalNote: string;
  schedule: KillswitchSchedule;
  scope: KillswitchScope;
  userId: string;
  version: number;
  capabilityKey: KillswitchCapabilityKey;
  status: KillswitchStatus;
};

/** @internal */
export const KillswitchDetail$inboundSchema: z.ZodMiniType<
  KillswitchDetail,
  unknown
> = z.pipe(
  z.object({
    capability_label: z.string(),
    external_note: z.string(),
    history: z.array(KillswitchHistoryEvent$inboundSchema),
    history_truncated: z.boolean(),
    id: z.string(),
    internal_note: z.string(),
    schedule: KillswitchSchedule$inboundSchema,
    scope: KillswitchScope$inboundSchema,
    user_id: z.string(),
    version: z.int(),
    capability_key: KillswitchCapabilityKey$inboundSchema,
    status: KillswitchStatus$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "capability_label": "capabilityLabel",
      "external_note": "externalNote",
      "history_truncated": "historyTruncated",
      "internal_note": "internalNote",
      "user_id": "userId",
      "capability_key": "capabilityKey",
    });
  }),
);

export function killswitchDetailFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchDetail, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchDetail$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchDetail' from JSON`,
  );
}
